export const MetaConfig = {
  homepage: {
    title: 'Five & Done QA Tools Suite',
    description: 'A suite of AI-powered quality assurance tools to streamline your testing workflow',
  },
  testCase: {
    title: 'AI Test Case Generator | Five & Done QA Tools',
    description: 'Transform requirements, screenshots, or Figma designs into comprehensive test cases with AI. Export to TestRail, Zephyr Scale, Jira, and more.',
  },
}

export function updateMetaTags(title: string, description: string, url: string): void {
  // Update title
  document.title = title

  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute('content', description)
  }

  // Update Open Graph tags
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle) {
    ogTitle.setAttribute('content', title)
  }

  const ogDescription = document.querySelector('meta[property="og:description"]')
  if (ogDescription) {
    ogDescription.setAttribute('content', description)
  }

  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl) {
    ogUrl.setAttribute('content', url)
  }

  // Update Twitter Card tags
  const twitterTitle = document.querySelector('meta[name="twitter:title"]')
  if (twitterTitle) {
    twitterTitle.setAttribute('content', title)
  }

  const twitterDescription = document.querySelector('meta[name="twitter:description"]')
  if (twitterDescription) {
    twitterDescription.setAttribute('content', description)
  }
}
